export default {
  path: '/doctor',
  component: () => import('../../views/doctor/doctor-router.vue'),
  children: [
    {
      path: '',
      name: 'Doctor',
      component: () => import('../../views/doctor/pages/Doctor.vue'),
      meta: {
        name: 'navigationDrawer.doctor',
        icon: '/icons/doctor.svg',
        auth: true
      }
    },
    {
      path: 'doctor-detail/:id',
      name: 'DoctorDetail',
      component: () => import('../../views/doctor/pages/DoctorDetail/DoctorDetail.vue'),
      meta: {
        name: 'navigationDrawer.doctor',
        icon: '/icons/doctor.svg',
        auth: true
      }
    },
    {
      path: 'doctor-edit/:id',
      name: 'DoctorEdit',
      component: () => import('../../views/doctor/pages/DoctorEdit.vue'),
      meta: {
        name: 'navigationDrawer.doctor',
        icon: '/icons/doctor.svg',
        auth: true
      }
    },
    {
      path: 'doctor-create',
      name: 'DoctorCreate',
      component: () => import('../../views/doctor/pages/DoctorCreate.vue'),
      meta: {
        name: 'navigationDrawer.doctor',
        icon: '/icons/doctor.svg',
        auth: true
      }
    }
  ]
}
